import { render } from "./TableClient.vue?vue&type=template&id=48aa0f72&scoped=true"
import script from "./TableClient.vue?vue&type=script&lang=js"
export * from "./TableClient.vue?vue&type=script&lang=js"

import "./TableClient.vue?vue&type=style&index=0&id=48aa0f72&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aa0f72"]])

export default __exports__